export const SM = 340;
export const SMMD = 600;
export const MD = 768;
export const MDLG = 992;
export const LG = 1200;
export const XL = 1920;

export const PHONE = `(min-width: ${SM}px)`;
export const PHONELG = `(min-width: ${SMMD}px)`;
export const TABLET = `(min-width: ${MD}px)`;
export const LAPTOP = `(min-width: ${MDLG}px)`;
export const DESKTOP = `(min-width: ${LG}px)`;


// WEBPACK FOOTER //
// ./src/utilities/breakpoints.js